import "assets/scss/components/conversation/item.scss";
import React from "react";
import { useApp } from "context";
import { Custom } from "components";
import { Helpers } from "utils";
import { Chat } from "types";
import { Box, Typography } from "@mui/material";
import KeyboardArrowRightIcon from "@mui/icons-material/KeyboardArrowRight";

type Props = {
  item: Chat;
  index: number;
  isLast: boolean;
  selected: boolean;
  onClick?: (item: Chat, index: number) => void;
};

export const Item = (props: Props) => {
  const { locale, t, theme } = useApp();

  const receiver = props.item.receiver;
  const receiverUsername = Helpers.replaceComma(receiver?.username ?? "");

  const handleClick = () => {
    props.onClick && props.onClick(props.item, props.index);
  };

  return (
    <div
      className={Helpers.classNames(
        "qh-conversation-item",
        props.selected && "selected"
      )}
      style={{
        backgroundColor: props.selected ? theme.color.primary.color : "",
      }}
      onClick={handleClick}
    >
      <div className="qh-wrapper">
        {/* <Custom.Avatar name={this.receiverUsername} /> */}
        <div className="qh-content">
          <div className="qh-line">
            <Typography
              component="span"
              className="o-ellipsis"
              sx={{ fontSize: theme.font.md }}
            >
              {receiverUsername}
            </Typography>
            <Typography component="span" sx={{ fontSize: theme.font.sm }}>
              {Helpers.toRelativeDate(
                props.item.lastMessage.messageTime,
                t.relative_date,
                locale,
                true
              )}
            </Typography>
          </div>
          <div className="qh-line">
            <Typography className="o-ellipsis" sx={{ fontSize: theme.font.sm }}>
              {props.item.lastMessage.content}
            </Typography>
            <div className="qh-trailing">
              <KeyboardArrowRightIcon />
            </div>
          </div>
        </div>
      </div>
      {!props.isLast && (
        <Box
          sx={{
            height: "1px",
            width: "100%",
            backgroundColor: theme.palette.background.color,
          }}
        ></Box>
      )}
    </div>
  );
};
